import { render, staticRenderFns } from "./MerchantDocuments.vue?vue&type=template&id=76145d43&scoped=true"
import script from "./MerchantDocuments.vue?vue&type=script&lang=js"
export * from "./MerchantDocuments.vue?vue&type=script&lang=js"
import style0 from "./MerchantDocuments.vue?vue&type=style&index=0&id=76145d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76145d43",
  null
  
)

export default component.exports